import { defineComponent as d, ref as c, computed as i, toRef as v, resolveComponent as y, openBlock as g, createBlock as O, normalizeClass as S, withCtx as P, createElementVNode as C, mergeProps as k, withModifiers as $, renderSlot as w } from "vue";
import { usePopoverState as h } from "@onereach/ui-components-common/hooks";
import { O as B, a as M } from "./OrPopover-DbygLPtT.mjs";
import "@onereach/ui-components-common/utils";
import { _ as b } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const j = [
  // Layout
  "overflow-y-auto",
  // Box
  "min-w-[160px]",
  "md:max-w-[256px]",
  "max-h-[340px]"
], A = d({
  name: "OrMenu",
  components: {
    OrPopover: B
  },
  inheritAttrs: !1,
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    trigger: {
      type: Object,
      default: void 0
    },
    placement: {
      type: String,
      default: () => M.Bottom
    },
    offset: {
      type: [Number, Object, Function],
      default: 8
    },
    // TODO: Remove after migration to Vue 3
    additionalStyles: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "open",
    "close",
    "toggle"
  ],
  setup(e, o) {
    const s = c(), p = i(() => [
      "or-menu-v3",
      ...j
    ]), a = i(() => [
      "or-menu-popover-v3"
    ]), { state: l, open: r, close: t, toggle: m } = h(v(e, "isOpen"), o.emit);
    function f(u) {
      u.composedPath().some(({ classList: n }) => n == null ? void 0 : n.contains("or-menu-item-v3")) && t();
    }
    return {
      root: s,
      rootStyles: p,
      popoverStyles: a,
      state: l,
      open: r,
      close: t,
      toggle: m,
      onClick: f
    };
  }
});
function N(e, o, s, p, a, l) {
  const r = y("OrPopover");
  return g(), O(r, {
    class: S(e.popoverStyles),
    "custom-styles": e.popoverStyles,
    "is-open": e.state === "open",
    variant: "auto",
    trigger: e.trigger,
    placement: e.placement,
    offset: e.offset,
    "keep-alive": !1,
    "onUpdate:state": o[1] || (o[1] = (t) => t === "open" ? e.open() : e.close())
  }, {
    default: P(() => [
      C("div", k(e.$attrs, {
        ref: "root",
        class: [e.rootStyles, ...e.additionalStyles],
        onClick: o[0] || (o[0] = $((t) => e.onClick(t), ["stop"]))
      }), [
        w(e.$slots, "default")
      ], 16)
    ]),
    _: 3
  }, 8, ["class", "custom-styles", "is-open", "trigger", "placement", "offset"]);
}
const q = /* @__PURE__ */ b(A, [["render", N]]);
export {
  q as O
};
//# sourceMappingURL=OrMenu-CJT4Snay.mjs.map
